import React from 'react';
import { Tooltip, Button } from '@mui/material';
import { PayReportDownloadStatus } from 'app/constants/report';
import { DOES_NOT_USE_CHECK_NUMBERS_REGIONS } from '../../constants/region-utils';
import { getUserRegion } from '../../../utils';
import moment from 'moment-timezone';

// Only used on Hauler and Vendor pages, therefore we can assume that paymentType cannot be deferral, and all tasks are async
const PayReportDownloadButtons = ({ canStartTask, dispatchTask, setCheckNumberDialogOpen, setDialogOpen, setUnapprovedDialogOpen, paymentType, payReports }) => {
    const region = getUserRegion();
    const usesCheckNumbers = !DOES_NOT_USE_CHECK_NUMBERS_REGIONS.includes(region);

    const checkIfReportsAreApproved = () => {
        return payReports[paymentType]?.some((report) => report?.report_data?.[`approved_${paymentType}_report`] === true);
    };

    const checkIfReportsAreNotPublished = () => {
        if (!checkIfReportsAreApproved()) return false;
        return payReports[paymentType]?.every((report) => {
            const reportPublishDate = report?.report_data?.[`${paymentType}_report`]?.publish_date;
            return reportPublishDate != null && moment().isBefore(moment(reportPublishDate));
        });
    };

    const buttonShouldBeDisabled = () => {
        return checkIfReportsAreApproved() || !canStartTask || payReports[paymentType]?.length === 0;
    };

    const handleDownloadAll = (payReportDownloadStatus) => {
        // Prevent check numbers from being reassigned to approved reports
        if (!checkIfReportsAreApproved() && usesCheckNumbers && payReportDownloadStatus === PayReportDownloadStatus.download) {
            setCheckNumberDialogOpen(true);
        } else {
            dispatchTask({ payReportDownloadStatus });
        }
    };

    const hasMissingPaymentStatus = () => {
        return usesCheckNumbers && payReports[paymentType]?.some((report) => report?.payment_number == null && report?.payment_method !== 'not_paid');
    };

    const enableApprovalTooltip = () => {
        return usesCheckNumbers && (buttonShouldBeDisabled() || hasMissingPaymentStatus()) && !checkIfReportsAreApproved();
    };

    return (
        <>
            <div>
                <Button color="primary" variant="contained" disabled={buttonShouldBeDisabled()} onClick={() => handleDownloadAll(PayReportDownloadStatus.calculate)}>
                    Calculate Pay
                </Button>
                <Button color="primary" variant="contained" sx={{ marginLeft: '5px' }} disabled={buttonShouldBeDisabled()} onClick={() => handleDownloadAll(PayReportDownloadStatus.download)}>
                    {usesCheckNumbers ? 'Generate Payments' : 'Download All'}
                </Button>
                {!checkIfReportsAreNotPublished() && (
                    <Tooltip title={enableApprovalTooltip() ? 'Generate payments before approving. This creates the payment records used for checks and ACH.' : ''} arrow placement="top">
                        {/* span required to keep tooltip active for a disabled button */}
                        <span>
                            <Button color="primary" variant="contained" sx={{ marginLeft: '5px' }} disabled={buttonShouldBeDisabled() || hasMissingPaymentStatus()} onClick={() => setDialogOpen(true)}>
                                Approve All
                            </Button>
                        </span>
                    </Tooltip>
                )}
                {checkIfReportsAreNotPublished() && (
                    <Button color="primary" variant="contained" sx={{ marginLeft: '5px' }} className="ml-12" onClick={() => setUnapprovedDialogOpen(true)}>
                        Unapprove All
                    </Button>
                )}
            </div>
        </>
    );
};

export default PayReportDownloadButtons;
